import { render } from "./Litigations.vue?vue&type=template&id=b2df8c26"
import script from "./Litigations.vue?vue&type=script&LitigationsTableSetup=true&lang=js"
export * from "./Litigations.vue?vue&type=script&LitigationsTableSetup=true&lang=js"

import "./Litigations.vue?vue&type=style&index=0&id=b2df8c26&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__